// It is not simply possible to remove the replace properties
// When a sub-navigation element is present this breaks the UI
// Also it isn't allowed to emit the scope parameter
(function () {
    'use strict';

    // From style guide: https://github.com/johnpapa/angular-styleguide/blob/master/a1/README.md
    // This immediately communicates which directives, services etc are declared in a given file
    // They can then be brought into view using the IDE 'go to definition' functionality
    angular.module('app')
        .directive('habilNavigation', NavigationDirective)
        .directive('habilNavigationTab', NavigationTabDirective)
        .directive('habilNavigationTabSub', NavigationSubTabDirective);

    // TODO: NavigationService

    NavigationDirective.$inject = ['$rootScope', 'tabNavigationService'];
    function NavigationDirective($rootScope, tabNavigationService) {
        return {
            restrict: 'E',
            // eslint-disable-next-line angular/no-directive-replace
            replace: true,
            transclude: true,
            scope: {},
            controller: ['$scope', function ($scope) {
                const tabs = $scope.tabs = [];

                this.addTab = function (tab) {
                    $scope.tabs.push(tab);

                    if (tab.selected === "selected") {
                        setTab(tab);
                    }
                };

                this.setTab = setTab;

                function setTab(tab) {
                    if (!tab) 
                        return;

                    angular.forEach(tabs, function (t) {
                        t.selected = false;
                    });
                    tab.selected = true;

                    tabNavigationService.SetActive(tab);
                    $rootScope.$broadcast("pdf_shown", tab);
                    $('html,body').animate({ scrollTop: 0 }, 'fast');
                }

                function getCurrentSelected() {
                    let currentTab = null;
                    angular.forEach(tabs, function (t) {
                        if (t.selected) {
                            currentTab = t;
                        }
                    });
                    return currentTab;
                }

                $scope.$on("actionBar_previousClick", function (_event) {
                    let currentIndex = tabs.indexOf(getCurrentSelected());

                    // skip hidden links
                    while (currentIndex > 0 && $(tabs[currentIndex - 1].element).is(":hidden")) {
                        currentIndex--;
                    }

                    if (currentIndex > 0) {
                        setTab(tabs[currentIndex - 1]);
                    }
                });

                $scope.$on("actionBar_nextClick", function (_event) {
                    let currentIndex = tabs.indexOf(getCurrentSelected());

                    // skip hidden links
                    while (currentIndex < tabs.length - 1 && $(tabs[currentIndex + 1].element).is(":hidden")) {
                        currentIndex++;
                    }

                    if (currentIndex < tabs.length - 1) {
                        setTab(tabs[currentIndex + 1]);
                    }
                });

                $scope.$on("go_to_tab", function (_event, tabKey) {
                    let currentIndex = tabs.indexOf(getCurrentSelected());

                    // skip hidden links
                    while (currentIndex < tabs.length - 1 && $(tabs[currentIndex + 1].element).is(":hidden")) {
                        currentIndex++;
                    }

                    let tab = null;
                    for (const t of tabs) {
                        if (t.key !== tabKey) continue;
                        tab = t;
                        break;
                    }
                    setTab(tab);
                });

                $scope.$on("go_to_Persons", function () {
                    let currentIndex = tabs.indexOf(getCurrentSelected());

                    // skip hidden links
                    while (currentIndex < tabs.length - 1 && $(tabs[currentIndex + 1].element).is(":hidden")) {
                        currentIndex++;
                    }

                    let tab = null;

                    angular.forEach(tabs, function (t) {
                        if (t.key === "persons") {
                            tab = t;
                        }
                    });

                    setTab(tab);
                });

                $scope.$on("validation_GoToNextInvalidatedTab", function () {
                    const selected = getCurrentSelected();

                    const nextTab = _.filter(tabs, t => t.$id > selected.$id && t.isInvalidated == true);
                    setTab(nextTab[0]);
                });

                $scope.$on("goToFirstInvalidatedTab", function () {
                    const nextTab = _.filter(tabs, t => t.isInvalidated == true);
                    setTab(nextTab[0]);
                });
            }],
            templateUrl: '@/navigation/habil-navigation.html'
        };
    }

    function NavigationTabDirective() {
        return {
            require: '^habilNavigation',
            restrict: 'E',
            // eslint-disable-next-line angular/no-directive-replace
            replace: true,
            transclude: true,
            scope: {
                key: '@key',
                label: '@label',
                selected: '@selected',
                isInvalidated: '=',
                isDisabled: '='
            },
            link: function (scope, element, _attrs, tabsCtrl) {
                scope.element = element[0];
                tabsCtrl.addTab(scope);
                scope.setTab = function () {
                    if (scope.isDisabled)
                        return;
                    tabsCtrl.setTab(this);
                };
                scope.GetStyle = getStyle;
                function getStyle() {
                    if (scope.isDisabled)
                        return 'disabledTab';
                    if (scope.isInvalidated)
                        return 'invalidated';
                    return '';
                }
            },
            templateUrl: '@/navigation/habil-navigation-tab.html'
        };
    }

    function NavigationSubTabDirective() {
        return {
            require: '^habilNavigation',
            restrict: 'E',
            // eslint-disable-next-line angular/no-directive-replace
            replace: true,
            transclude: true,
            scope: {
                key: '@key',
                label: '@label',
                selected: '@selected'
            },
            link: function (scope, element, _attrs, tabsCtrl) {
                scope.element = element[0];
                tabsCtrl.addTab(scope);
                scope.setTab = function () {
                    if (this.key !== '')
                        tabsCtrl.setTab(this);
                };
            },
            templateUrl: '@/navigation/habil-navigation-tab-sub.html'
        };
    }
})();
